export const paths = {
  root: '/',
  unknown: '*',
  dashboard: {
    root: '/admin',
    initial: 'initial',
    partners: 'partners/externals',
    companies: 'partners/companies',
    redeems: 'partners/redeemables',
    createPartnes: 'partners/create',
    createCompanies: 'partners/companies/create',
    banners: '/admin/banners',
    bannerDetails: (id: string) => `/admin/banner-details/${id}`,
    admsList: '/admin/adms/list',
    admDetails: (id: string) => `/admin/adm-details/${id}`,
    clients: '/admin/adms/clients',
    clientDetails: (id: string) => `/admin/adms/client-details/${id}`,
    shopkeepersList: '/admin/adms/shopkeepers',
    shopkeeperDetails: (id: string) => `/admin/adms/shopkeeper-details/edit/${id}`,
    shopkeeperCreate: '/admin/adms/shopkeeper-details/create',
    admCreate: `/admin/adms/adm-create`,
    admEdit: (id: string) => `/admin/adms/adm-edit/${id}`,
    partnerDetails: (id: string) => `/admin/partners/edit/${id}`,
    companyDetails: (id: string) => `/admin/partners/companies/edit/${id}`,
    transactionCreate: '/admin/transactions/input-list/create',
    transactionEdit: (id: string) => `/admin/transactions/input-list/edit/${id}`,
    transactions: '/admin/transactions/input-list',
    conciliations: '/admin/transactions/conciliations',
    promotionsList: '/admin/benefits/promotions-list',
    promotionDetails: (id: string) => `/admin/promotion-details/edit/${id}`,
    promotionCreate: '/admin/promotion-details/create',
    couponsList: '/admin/benefits/coupons-list',
    benefitsList: '/admin/benefits/benefits-list',
    benefitsDetails: '/admin/benefits/details/create',
    benefitsDetailsEdit: (id: string) => `/admin/benefits/details/edit/${id}`,
    eventsList: '/admin/benefits/events-list',
    eventDetails: (id: string) => `/admin/benefits/event-details/edit/${id}`,
    eventCreate: '/admin/benefits/event-details/create',
    credit: '/admin/credit',
    personalizationList: '/admin/personalization/app-texts',
    personalizationDetails: (id: string) => `/admin/personalization/details/${id}`,
    appTerms: '/admin/personalization/app-terms',
    regulations: '/admin/personalization/regulations',
    promotionalRegulations: '/admin/personalization/promotional',
    promotionalRegulationsEdit: (id: string) =>
      `/admin/personalization/promotional/details/edit/${id}`,
    promotionalRegulationsCreate: `/admin/personalization/promotional/details/create`,
    promotersList: '/admin/promoter/promoters',
    promotersEdit: (id: string) => `/admin/promoter/promoters/edit/${id}`,
    promotersCreate: '/admin/promoter/promoters/create',
    promoterTermsList: '/admin/promoter/terms',
    themesCategoriesList: '/admin/benefits/themes-categories-list',
    categoryList: '/admin/benefits/category-list',
    categoryDetails: (id: string) => `/admin/category-details/edit/${id}`,
    categoryCreate: '/admin/category-details/create',
    themeList: '/admin/benefits/theme-list',
    themeDetails: (id: string) => `/admin/theme-details/edit/${id}`,
    themeCreate: '/admin/theme-details/create',
    collectionsList: '/admin/benefits/collections-list',
    collectionsDetails: (id: string) => `/admin/benefits/collection-details/edit/${id}`,
    collectionsCreate: '/admin/collection-details/create',
    collectibleCreate: `/admin/benefits/collectible-details/create`,
    collectibleDetails: (id: string) => `/admin/benefits/collectible-details/edit/${id}`,
    faq: '/admin/personalization/faq',
    faqDetails: (id: string) => `/admin/personalization/faq-details/edit/${id}`,
    faqCreate: '/admin/personalization/faq-details/create',
    configurations: '/admin/configurations',
    lpEvents: '/admin/lp-events',
    missionsPage: '/admin/missions',
    missionDetails: (id: string) => `/admin/mission-details/edit/${id}`,
    missionCreate: '/admin/mission-details/create',
    fairList: '/admin/benefits/fairs',
    fairDetails: (id: string) => `/admin/benefits/fairs/edit/${id}`,
    fairCreate: '/admin/benefits/fairs/create',
    scnEventsList: '/admin/benefits/scn-events',
    scnEventDetails: (id: string) => `/admin/benefits/scn-events/edit/${id}`,
    scnEventCreate: '/admin/benefits/scn-events/create',
    lpEventsList: '/admin/lp-events/events-lp',
    lpEventDetails: (id: string) => `/admin/lp-events/events-lp/edit/${id}`,
    lpEventCreate: '/admin/lp-events/events-lp/create',
    onboarding: '/admin/personalization/onboarding',
    homeBand: '/admin/personalization/home-band',
    homeBandDetails: (id: string) => `/admin/personalizat/lp-eventson/home-band-details/edit/${id}`,
    homeBandCreate: '/admin/personalization/home-band-details/create',
    homeBanner: '/admin/personalization/home-banner',
    homeBannerDetails: (id: string) => `/admin/personalization/home-banner-details/edit/${id}`,
    homeBannerCreate: '/admin/personalization/home-banner-details/create',
    lpCouponsList: '/admin/lp-events/coupons',
    lpCouponDetails: (id: string) => `/admin/lp-events/coupons/edit/${id}`,
    lpCouponCreate: '/admin/lp-events/coupons/create',
    lpProductsList: '/admin/lp-events/products',
    lpProductDetails: (id: string) => `/admin/lp-events/products/edit/${id}`,
    lpProductCreate: '/admin/lp-events/products/create',
    productApproval: '/admin/lp-events/products',
    couponApproval: '/admin/lp-events/coupons',
    lpEventsPromoters: '/admin/lp-events/promoters',
    lpEventsPromoterCreate: '/admin/lp-events/promoters/create',
    lpEventsPromoterDetails: (id: string) => `/admin/lp-events/promoters/edit/${id}`,
    lpEventsParticipants: '/admin/lp-events/participant',
    lpEventsParticipantCreate: '/admin/lp-events/participant/create',
    lpEventsParticipantDetails: (id: string) => `/admin/lp-events/participant/edit/${id}`,
    lpEventsBanners: '/admin/lp-events/banners',
    lpEventsBannerCreate: '/admin/lp-events/banners/create',
    lpEventsBannerDetails: (id: string) => `/admin/lp-events/banners/edit/${id}`,
    trails: '/admin/trails/trails',
    trailCreate: '/admin/trails/trails/create',
    trailDetails: (id: string) => `/admin/trails/trails/edit/${id}`,
    seasons: '/admin/trails/seasons',
    seasonCreate: '/admin/trails/seasons/create',
    seasonDetails: (id: string) => `/admin/trails/seasons/edit/${id}`,
  },
  auth: {
    root: '/auth',
    login: 'login',
    register: 'register',
    resetPassword: 'reset-password',
    verify: 'verify',
  },
};
